import './KbAgent.css'
import { BasicPage } from '@/components/layout/BasicPage'
import { Button } from '@/components/action/Button'
import { AgentChat } from '@/components/agentChat/AgentChat'
import { useApi } from '@/hooks/useApi'
import { routes } from '@/utilities/routes'

export function KbAgent() {

  useApi({ requireLogin: true, adminOnly: true })

  return (
    <BasicPage
      title='KB Agent'
      className='KbAgent'
      toolbarButtons={<>
        <Button
          label='Articles'
          icon='chevronLeft'
          href={routes.adminKbArticles()}
        />
      </>}
    >

      <div className='Cutout ChatContainer'>
        <AgentChat agent='kb' width='100%' persistenceKey='kb' />
      </div>

      <div className='Cutout Workspace'>
        To do
      </div>

    </BasicPage>
  )
}
